import axios from 'axios'
import {BUSCAR_USUARIO_POR_EMAIL} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarUsuarioPorEmail(email, idEmpresa) {
    const url = `${URL}/usuarios/empresa/${idEmpresa}/email/${email}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_USUARIO_POR_EMAIL,
            payload: response

        })
    );
}
